import { render, staticRenderFns } from "./myAppointDetail.vue?vue&type=template&id=18f5b014&scoped=true&"
import script from "./myAppointDetail.vue?vue&type=script&lang=js&"
export * from "./myAppointDetail.vue?vue&type=script&lang=js&"
import style0 from "./myAppointDetail.vue?vue&type=style&index=0&id=18f5b014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5b014",
  null
  
)

export default component.exports